import { Skeleton } from '@mui/material/';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
const SkeletonHeader = () => {
    var SiteData = useSelector(state => state.SiteData);
    const countryDropdown = SiteData.hidesetaddress;
    const hidecategories = SiteData.hidecategories;
    var mdSize2 = 6;
    if ( countryDropdown || hidecategories ) {
        mdSize2 = 12;
    }
    return(
        <Box sx={{ flexGrow: 1, bgcolor: '#efefef', padding:'10px', marginBottom:'5px' }} className="skHeader">
            <Grid container className="rslStoresHeader1" style={{marginBottom:'8px'}}>
                <Grid item xs={12} md={6}>
                    <Skeleton className="skAutocomplete" style={{marginRight:'5px', marginBottom:'5px'}} variant="rectangular" height={50} />
                </Grid>
                {(!SiteData.hiderange) ? 
                    <Grid item xs={12} md={6}>
                        <Skeleton className="skRadius" variant="rectangular" height={50} />
                    </Grid>
                : ''}
            </Grid>
            <Grid container className="rslStoresHeader2">
                {('tabs' === SiteData.dropdownstyle && !hidecategories) ?
                    <Grid item xs={12} md={mdSize2}>
                        <Grid container className="skCategories">
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                        </Grid>
                        <Grid container className="skCategoriesGrid" style={{marginTop:'5px'}}>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={30} />
                            </Grid>
                        </Grid>
                    </Grid>
                : ''}
                {('dropdown' === SiteData.dropdownstyle && !hidecategories) ?
                    <Grid item xs={12} md={mdSize2}>
                        <Skeleton className="skCategories" style={{marginRight:'5px'}} variant="rectangular" height={50} />
                    </Grid> : ''}
                {(!SiteData.hidesetaddress) ?
                    <Grid item xs={12} md={mdSize2}>
                        <Grid container className="rslStoresHeader3">
                            <Grid item xs={12} md={4}>
                                <Skeleton className="skAddressesCountry" style={{marginRight:'5px'}} variant="rectangular" height={50} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Skeleton className="skAddressesState" style={{marginRight:'5px'}} variant="rectangular" height={50} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Skeleton className="skAddressesCity" style={{marginRight:'5px'}} variant="rectangular" height={50} />
                            </Grid>
                        </Grid>
                    </Grid>
                : ''}
            </Grid>
        </Box>
    )
}
export default SkeletonHeader;